import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { handleApi } from '../../../utils/authentication';
import { FaGreaterThan } from "react-icons/fa6";
import { getPlatformImg } from '../../../helpers/getImgSrc';
import { getPlatformName } from '../../../helpers/getPlatformName';
import { CommonModal } from '../../../components/CommonModal';
import LoadingSpinner from '../../../components/client/LoadingSpinner';

const ListAdsWithinCampaigns = ({ externalCampaign }) => {
  let params = useParams();
  const [adsList, setAdsList] = useState([]);
  const [externalCampaignDetails, setExternalCampaignDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [generateUtmModal, setGenerateUtmModal] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null); // To store the selected ad
  const [formLoading, setFormLoading] = useState(false)
  const [google_ads, setGoogleAds] = useState({
    google: [],
    youtube: []
  })
  const [showGoogleAds, setShowGoogleAds] = useState(false)
  const [showYoutubeAds, setShowYoutubeAds] = useState(false)

  const [utmParams, setUtmParams] = useState({
    website_url: '',
    campaign_id: params?.external_campaign_id || '', // Prefill campaign_id from params
    utm_source: '',
    utm_medium: '',
    utm_campaign: '', // Leave empty initially
    utm_term: '',
    utm_content: '',
    post_id:''
  });
  const [generatedUrl, setGeneratedUrl] = useState('');
  const [copied, setCopied] = useState(false); // Track if URL is copied
  const [saveUtmStatus, setSaveUtmStatus] = useState(''); // Track save status

  // Function to handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUtmParams((prev) => {
      const updatedParams = { ...prev, [name]: value };
      generateUtmUrl(updatedParams); // Automatically generate URL on input change
      return updatedParams;
    });
  };

  // Function to generate the UTM URL
  const generateUtmUrl = (params) => {
    const { website_url, campaign_id, utm_source, utm_medium, utm_campaign, utm_term, utm_content } = params;

    // Basic validation: Ensure all required fields are filled
    if (!website_url || !campaign_id || !utm_source || !utm_medium || !utm_campaign) {
      setGeneratedUrl(''); // Clear the URL if required fields are missing
      return;
    }

    // Construct the UTM URL
    let url = `${website_url}?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_id=${campaign_id}`;

    if (utm_term) url += `&utm_term=${utm_term}`;
    if (utm_content) url += `&utm_content=${utm_content}`;

    setGeneratedUrl(url); // Update the generated URL
  };

  // Fetch ads list and external campaign details (keep existing API logic intact)
  const getAdsWithinCampaigns = async () => {
    try {
      setLoading(true);
      let formdata = new FormData();
      formdata.append('external_campaign_id', params?.external_campaign_id);
      formdata.append('platform_id', params?.platform_id);
      let response = await handleApi('list_campaign_ads', 'POST', {}, formdata);
      if (response?.success) {
        const campaignDetails = response?.data?.external_campaign_details;
        setExternalCampaignDetails(campaignDetails);

        let platform_name = getPlatformName(params?.platform_id)
        let google_ads = [];
        let youtube_ads = []
        if (platform_name === "Google") {
          if (response?.data?.ads_list?.length > 0) {
            response?.data?.ads_list?.map((ad) => {
              if (ad?.type_google_ads) {
                google_ads.push(ad)
              }
              if (ad?.type_youtube_ads) {
                youtube_ads.push(ad)
              }
            })
          }
          setGoogleAds({
            google: google_ads,
            youtube: youtube_ads

          })

        } else {
          setAdsList(response?.data?.ads_list);

        }



        // Update utm_campaign if campaign_name is available
        if (campaignDetails?.campaign_name && !utmParams.utm_campaign) {
          setUtmParams((prev) => ({
            ...prev,
            utm_campaign: campaignDetails?.campaign_name, // Prefill campaign_name
          }));
        }
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };



  useEffect(() => {
    if (params?.external_campaign_id && params?.platform_id) {
      getAdsWithinCampaigns();
    }
  }, [params?.external_campaign_id, params?.platform_id]);




  // Function to handle copying the URL to the clipboard
  const handleCopyUrl = () => {
    navigator.clipboard.writeText(generatedUrl);
    setCopied(true); // Set copied state to true
    setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
  };



  useEffect(() => {

    const getAdsDetails = async () => {
      try {
        setUtmParams({
          website_url: '',
          campaign_id: params?.external_campaign_id || '', // Prefill from params
          utm_source: '',
          utm_medium: '',
          utm_campaign: externalCampaignDetails?.campaign_name || '', // Prefill from externalCampaignDetails
          utm_term: '',
          utm_content: '',
          post_id:''
        });
        if (selectedAd?.id && selectedAd?.utm_flag) {
          setFormLoading(true)
          let formData = new FormData()
          formData.append('ads_id', selectedAd.id)
          formData.append('campaign_id', params?.external_campaign_id);
          formData.append('platform_id', params?.platform_id);
          let result = await handleApi('get_utm', 'POST', {}, formData)
          if (result?.success) {
            setUtmParams({
              website_url: result?.data?.website_url,
              campaign_id: params?.external_campaign_id || '', // Prefill from params
              utm_source: result?.data?.campaign_source,
              utm_medium: result?.data?.campaign_medium,
              utm_campaign: externalCampaignDetails?.campaign_name || '',
              utm_term: result?.data?.campaign_term,
              utm_content: result?.data?.campaign_content,
              post_id: result?.data?.post_id || '',
            });
            setGeneratedUrl(result?.data?.utm_url)


          }
        }
        setFormLoading(false)

      } catch (e) {
        console.log(e)
        setFormLoading(false)
      }



    }

    getAdsDetails()

  }, [selectedAd])



  // Function to save UTM to the backend
  const saveUtm = async () => {
    try {
      setSaveUtmStatus('Saving...');
      let formdata = new FormData();

      // Append UTM parameters to the form data
      formdata.append('website_url', utmParams.website_url);
      formdata.append('campaign_id', utmParams.campaign_id);
      formdata.append('campaign_source', utmParams.utm_source);
      formdata.append('campaign_medium', utmParams.utm_medium);
      formdata.append('campaign_name', utmParams.utm_campaign);
      formdata.append('campaign_term', utmParams.utm_term);
      formdata.append('campaign_content', utmParams.utm_content);
      formdata.append('post_id', utmParams.post_id);
      formdata.append('utm_url', generatedUrl);
      formdata.append('ads_id', selectedAd?.id); // Attach the selected ad ID
      formdata.append('platform_id', params?.platform_id); // Attach the platform ID

      // Make the API request to save UTM
      let endpoint = ""
      if (selectedAd?.utm_flag) {
        endpoint = "edit_utm"
      } else {
        endpoint = "create_utm"
      }
      let response = await handleApi(endpoint, 'POST', {}, formdata);
      if (response?.success) {
        setSaveUtmStatus('Saved!');
        getAdsWithinCampaigns()
      } else {
        setSaveUtmStatus('Failed to save');
      }
    } catch (e) {
      console.log(e);
      setSaveUtmStatus('Error occurred');
    }
  };

  // Reset state when modal is closed
  const handleModalClose = () => {
    setGenerateUtmModal(false);
    // setUtmParams({
    //   website_url: '',
    //   campaign_id: params?.external_campaign_id || '', // Prefill from params
    //   utm_source: '',
    //   utm_medium: '',
    //   utm_campaign: externalCampaignDetails?.campaign_name || '', // Prefill from externalCampaignDetails
    //   utm_term: '',
    //   utm_content: '',
    // }); // Reset the fields
  };



  return (
    <>
       {loading && <LoadingSpinner /> }
      {!loading && getPlatformName(params?.platform_id) != "Google" && <div className={`rounded-4 border border-2 pb-1`}>
        <div className="bg_primary py-3 px-3 rounded-3 text-white">
          <div className="d-flex justify-content-between w-100 align-items-center h-100">
            <div className="w-100 fw-bold">{externalCampaignDetails?.campaign_name}</div>
          </div>
        </div>
           {adsList?.length > 0? (
          <>
            {adsList?.map((ad) => (
              <div className="row px-1 py-3 mx-2 mt-1 mb-2 campaign_item_card border border-2" key={ad?.id}>
                <div className="col-lg-12 col-md-12">
                  <div className="d-flex flex-wrap justify-content-between my-2 pb-2 border-bottom">
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={getPlatformImg(params?.platform_id)}
                        className="img-fluid social_media_img"
                        alt=""
                      />
                      <p className="mb-0">{ad?.name} Post</p>
                    </div>
                    <span>{externalCampaign?.platform ? externalCampaign?.platform : ''} Platform</span>
                  </div>
                  <div className="row d-flex align-items-center mt-2">
                    <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                      <p className="mb-0">Type</p>
                      <span>{ad?.type}</span>
                    </div>
                    <div className="col-12 d-flex gap-4 justify-content-end">
                      <button
                        onClick={() => {
                          setSelectedAd(ad); // Set selected ad
                          setGenerateUtmModal(true); // Open UTM generation modal
                        }}
                        className="btn btn-primary btn-sm rounded-pill d-flex gap-2 align-items-center"
                      >
                        {ad?.utm_flag ? 'View UTM' : 'Generate UTM'} <FaGreaterThan />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center">
            <h5>No Ads Found</h5>
          </div>
        )}
       
       </div>
       }

      {!loading && getPlatformName(params?.platform_id) === "Google" && 
        <div className="accordion my-4 mx-2 custom-accordion campaign_item_card" id={`google_${externalCampaignDetails?.google_campaign_id}`}>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#google_${externalCampaignDetails?.google_campaign_id}_wrapper`}
                aria-expanded="true"
                aria-controls={`google_${externalCampaignDetails?.google_campaign_id}_wrapper`}
              >
                {externalCampaignDetails?.campaign_name}
              </button>
            </h2>
            <div
              id={`google_${externalCampaignDetails?.google_campaign_id}_wrapper`}
              className="accordion-collapse collapse show py-3 px-3"
            >
              <div className="accordion-body">


                {/* type google ads */}
                <div className="accordion my-4 mx-2 custom-accordion campaign_item_card" id={`google_ads_${externalCampaignDetails?.google_campaign_id}`}>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#google_ads_${externalCampaignDetails?.google_campaign_id}_wrapper`}
                        aria-expanded="true"
                        aria-controls={`google_ads_${externalCampaignDetails?.google_campaign_id}_wrapper`}
                      >
                        Google Ads
                      </button>
                    </h2>
                    <div
                      id={`google_ads_${externalCampaignDetails?.google_campaign_id}_wrapper`}
                      className="accordion-collapse collapse show py-3 px-3"
                    >
                      <div className="accordion-body">

                        {google_ads?.google?.length > 0 ? (
                          <>
                            {google_ads?.google?.map((ad) => (
                              <div className="row px-1 py-3 mx-2 mt-1 mb-2 campaign_item_card border border-2" key={ad?.id}>
                                <div className="col-lg-12 col-md-12">
                                  <div className="d-flex flex-wrap justify-content-between my-2 pb-2 border-bottom">
                                    <div className="d-flex align-items-center gap-2">
                                      <img
                                        src={getPlatformImg(params?.platform_id)}
                                        className="img-fluid social_media_img"
                                        alt=""
                                      />
                                      <p className="mb-0">{ad?.name} Post</p>
                                    </div>
                                    <span>{externalCampaign?.platform ? externalCampaign?.platform : ''} Platform</span>
                                  </div>
                                  <div className="row d-flex align-items-center mt-2">
                                    <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                                      <p className="mb-0">Type</p>
                                      <span>{ad?.type}</span>
                                    </div>
                                    <div className="col-12 d-flex gap-4 justify-content-end">
                                      <button
                                        onClick={() => {
                                          setSelectedAd(ad); // Set selected ad
                                          setGenerateUtmModal(true); // Open UTM generation modal
                                        }}
                                        className="btn btn-primary btn-sm rounded-pill d-flex gap-2 align-items-center"
                                      >
                                        {ad?.utm_flag ? 'View UTM' : 'Generate UTM'} <FaGreaterThan />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          <div className="d-flex justify-content-center align-items-center">
                            <h5>No Ads Found</h5>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>



                {/* type google ads */}
                <div className="accordion my-4 mx-2 custom-accordion campaign_item_card" id={`youtube_ads_${externalCampaignDetails?.google_campaign_id}`}>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#youtube_ads_${externalCampaignDetails?.google_campaign_id}_wrapper`}
                        aria-expanded="true"
                        aria-controls={`youtube_ads_${externalCampaignDetails?.google_campaign_id}_wrapper`}
                      >
                        Youtube Ads
                      </button>
                    </h2>
                    <div
                      id={`youtube_ads_${externalCampaignDetails?.google_campaign_id}_wrapper`}
                      className="accordion-collapse collapse show py-3 px-3"
                    >
                      <div className="accordion-body">

                        {google_ads?.youtube?.length > 0 ? (
                          <>
                            {google_ads?.youtube?.map((ad) => (
                              <div className="row px-1 py-3 mx-2 mt-1 mb-2 campaign_item_card border border-2" key={ad?.id}>
                                <div className="col-lg-12 col-md-12">
                                  <div className="d-flex flex-wrap justify-content-between my-2 pb-2 border-bottom">
                                    <div className="d-flex align-items-center gap-2">
                                      <img
                                        src={getPlatformImg(params?.platform_id)}
                                        className="img-fluid social_media_img"
                                        alt=""
                                      />
                                      <p className="mb-0">{ad?.name} Post</p>
                                    </div>
                                    <span>{externalCampaign?.platform ? externalCampaign?.platform : ''} Platform</span>
                                  </div>
                                  <div className="row d-flex align-items-center mt-2">
                                    <div className="col-lg-2 col-md-4 col-sm-4 col-6">
                                      <p className="mb-0">Type</p>
                                      <span>{ad?.type}</span>
                                    </div>
                                    <div className="col-12 d-flex gap-4 justify-content-end">
                                      <button
                                        onClick={() => {
                                          setSelectedAd(ad); // Set selected ad
                                          setGenerateUtmModal(true); // Open UTM generation modal
                                        }}
                                        className="btn btn-primary btn-sm rounded-pill d-flex gap-2 align-items-center"
                                      >
                                        {ad?.utm_flag ? 'View UTM' : 'Generate UTM'} <FaGreaterThan />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          <div className="d-flex justify-content-center align-items-center">
                            <h5>No Ads Found</h5>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      }






      {/* UTM Generation Modal */}
      <CommonModal
        size={'lg'}
        title={
          <>
            <div className="d-flex flex-column gap-1">
              <span className="fs-6 fw-bold">Generate UTM for {selectedAd?.name}</span>
            </div>
          </>
        }
        body={
          <div>
            {formLoading && <LoadingSpinner />}
            <div className="mb-3">
              <label className="form-label">Full Website URL <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                name="website_url"
                placeholder="e.g., https://www.example.com"
                value={utmParams.website_url}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Ad Campaign ID <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                name="campaign_id"
                placeholder="e.g., 123"
                value={utmParams.campaign_id}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Campaign Source <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                name="utm_source"
                placeholder="e.g., google"
                value={utmParams.utm_source}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Marketing Medium <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                name="utm_medium"
                placeholder="e.g., cpc, banner, email"
                value={utmParams.utm_medium}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Campaign Name <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                name="utm_campaign"
                placeholder="e.g., spring_sale"
                value={utmParams.utm_campaign}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Campaign Term (optional)</label>
              <input
                type="text"
                className="form-control"
                name="utm_term"
                placeholder="e.g., shoes, running, winter"
                value={utmParams.utm_term}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Campaign Content (optional)</label>
              <input
                type="text"
                className="form-control"
                name="utm_content"
                placeholder="e.g., banner_ad, text_ad"
                value={utmParams.utm_content}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Post Id (optional)</label>
              <input
                type="text"
                className="form-control"
                name="post_id"
                placeholder="e.g., banner_ad, text_ad"
                value={utmParams.post_id}
                onChange={handleInputChange}
              />
            </div>
            {generatedUrl ? (
              <div className="mt-3">
                <label className="mb-2">Generated URL</label>
                <textarea
                  type="text"
                  className="form-control utm_url"
                  value={generatedUrl}
                  rows={3}

                  readOnly
                  onClick={(e) => e.target.select()}
                />
                <div className='mt-2'>
                  <button className="btn btn-secondary mt-2" onClick={handleCopyUrl}>
                    {copied ? 'Copied!' : 'Copy URL'}
                  </button>
                  <button
                    className="btn btn-primary mt-2 ms-2"
                    onClick={saveUtm}
                  >
                    {saveUtmStatus || 'Save UTM'}
                  </button>

                </div>

              </div>
            ) : (
              <div className="mt-3 text-muted">
                <p>Fill all the required fields to generate the URL.</p>
              </div>
            )}
          </div>
        }
        show={generateUtmModal}
        setShow={handleModalClose} // Reset state on modal close
      />
    </>
  );
};

export default ListAdsWithinCampaigns;
